//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProfileData from '~/components/profile/ProfileData'
import { formatDate } from '~/utils/utils'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/ru'
import 'vue2-datepicker/index.css'
import MtModal from '~/components/Modal/MtModal'
import MtInput from '~/components/form/MtInput'

export default {
  components: {
    MtInput,
    MtModal,
    ProfileData,
    DatePicker
  },
  props: {
    myProfileData: {
      type: Object,
      require: true,
      default: () => {}
    }
  },
  data (){
    return {
      recurrentList: null,
      subscriptionAside: false,
      modal: null,
      choosenId: null,
      edit: false,
      cardData: null,
      formError: null,
      deleteError: null
    }
  },
  computed: {
  },
  methods:{
    currentNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
    },
    startUpdateCard(card) {
      this.edit = true
      this.cardData = {
        ...card,
        dateTime: new Date(card.dateTime * 1000)
      }
    },
    updateCard() {
      this.formError = null
      const { dateTime, amount, id } = this.cardData
      if (!dateTime || !amount) {
        this.formError = this.$t('profileSettings.formError')
        return
      } else if (Number(amount) < 100) {
        return
      }
      let date = this.getCurrentData(dateTime) === this.getCurrentData(new Date()) ? new Date().getTime() + 20000 : dateTime.getTime()
      date = (date / 1000).toFixed()
      this.$axios({
        method: 'get',
        url: `/api/v1/donate/updateRecurrent?lang=${this.$i18n.locale || 'ru'}&recurrentId=${id}&amount=${amount}&dateAmount=${date}`
      })
        .then(({data}) => {
          if (data.error) {
            this.formError = data.error.message
          } else {
            this.toggleDetailSubscription()
            this.recurrentList = data.data
          }
        })
        .catch(err => {
          console.log('ошибка при запросе на донат', err)
        })
    },
    toggleDetailSubscription(index = null){
      this.activeCard = this.recurrentList[index]
      this.cardData = null
      this.edit = false
      this.deleteError = null
      this.subscriptionAside = !this.subscriptionAside
    },
    showConfirmModal(id, message, buttonAction) {
      this.deleteError = null
      this.choosenId = id
      this.modal = {
        title: this.$t('profile.confirmModalTitle'),
        message,
        buttonAction
      }
    },
    // unlinkCard(id) {
    //   this.$axios({
    //     method: 'post',
    //     url: `/api/v1/donate/removeRecurrent`,
    //     data: `recurrentId=${id}`
    //   }).then(({data}) => {
    //     this.subscriptionAside = false
    //     this.recurrentList.reload()
    //   })
    // },
    currentCardNumber(number) {
      let result = []
      for (let i = 0; i < number.length; i += 4) {
        if (i < 12) {
          result.push('****');
        } else {
          const str = number.slice(i, i + 4)
          result.push(str.replace(/x/g, '*'));
        }
      }
      return result.join(' ')
    },
    getCurrentData(data) {
      return formatDate(data, 'DD.MM.YYYY')
    },
    buttonActions(action) {
      if (action === 'unlinkCard' || action === 'updateFollow') {
        this.$axios({
          method: 'post',
          url: `/api/v1/donate/removeRecurrent`,
          data: `lang=${this.$i18n.locale || 'ru'}&recurrentId=${this.choosenId}`
        }).then(({data}) => {
          this.modal = null
          if (data.error) {
            this.deleteError = data.error.message
          } else {
            this.subscriptionAside = false
            this.choosenId = null
            this.getRecurrentList.reload()
            if (action === 'updateFollow') {
              this.$store.commit('forms/openDonatForm')
            }
          }
        })
      }
    }
  },
  chimera: {
    getRecurrentList () {
      return {
        method: 'post',
        url: '/api/v1/donate/recurrentList',
        key: 'recurrentList',
        auto: true,
        prefetch: false,
        params: {
          active: true,
          lang: this.$i18n.locale || 'ru'
        },
        on: {
          success () {
            this.recurrentList = this.getRecurrentList.data.data
          }
        }
      }
    }
  }
}
